import React, { useState, useEffect } from 'react';

const STORAGE_KEY = 'sati_sidebar_collapsed';

const SidebarContext = React.createContext({});

function SidebarProvider(props) {
    const [collapsed, setCollapsedState] = useState(() => {
        try {
            return localStorage.getItem(STORAGE_KEY) === 'true';
        } catch (_) {
            return false;
        }
    });

    useEffect(() => {
        try {
            localStorage.setItem(STORAGE_KEY, collapsed ? 'true' : 'false');
        } catch (_) {}
    }, [collapsed]);

    const setCollapsed = (value) => setCollapsedState(Boolean(value));
    const toggle = () => setCollapsedState(prev => !prev);

    return (
        <SidebarContext.Provider value={{ collapsed, setCollapsed, toggle }}>
            {props.children}
        </SidebarContext.Provider>
    );
}

export { SidebarContext, SidebarProvider };
